import React from 'react';
import './PickPayment.scss';
import PaymentItem from 'Components/PickPayment/PaymentItem';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';

interface IProps {
  totalPrice: number;
  paymentMethods: Julius.Website.PaymentMethodViewModel[];
  selectedPaymentName: string;
  onPaymentItemChange: (paymentName: string, isChecked: boolean) => void;
}

const PickPayment: React.SFC<IProps> = ({
  totalPrice,
  paymentMethods,
  selectedPaymentName,
  onPaymentItemChange,
}) => {

  const Header = () => (
    <FormattedText 
      style='title'
      displayName='Välj betalsätt'
      formattedName='order.payment.header'
    />  
  );

  if (totalPrice === 0) {
    return (
      <div className='pick-payment'>
        <Header />
        <FormattedText 
          style='payment-message'
          displayName={
            `Det finns ingenting att betala. Godkänn 
            köpvillkoren för att slutföra beställningen.` 
          }
          formattedName='order.payment.zerosum'
        />
      </div>
    );
  }

  if (totalPrice < 0) {
    return (
      <div className='pick-payment'>
        <Header />
        <FormattedText 
          style='payment-message'
          displayName={
            `Det finns ingenting att betala. Den negativa 
            summan kommer att läggas på som ett presentkort 
            på din nya beställning. Godkänn köpvillkoren 
            för att slutföra beställningen.`
          }
          formattedName='order.payment.negativesum'
        />
      </div>
    );
  }

  if (!paymentMethods || !paymentMethods.length) {
    return null;
  }

  return (
    <div className='pick-payment'>
      <Header />
      { paymentMethods.map(p => 
        <PaymentItem 
          key={ p.name }
          isSelected={ p.name === selectedPaymentName }
          { ... { ...p, onPaymentItemChange } }
        />)
      }
    </div>
  );
}

export default PickPayment;


// WEBPACK FOOTER //
// ./src/components/PickPayment/PickPayment.tsx